import React, { FC } from 'react';
import { CardVertical, CardVerticalVariations, Types } from '@marriott/mi-ui-library';
import {
  findTrackingConfig,
  mapTrackingProperties,
} from '../../modules/utils/trackingHelper';
import { PointsCardGridProps } from './PointsWrapper.types';

export const PointsCardGrid: FC<PointsCardGridProps> = ({ cards, componentId, tracking }) => {
  if (!Array.isArray(cards) || cards.length === 0) return null;
  
  return (
    <div className="pointswrapper__cards" data-testid="points-wrapper-cards">
      {cards.map((card, index) => {
        if (!card?.header || !card?.ctaLink) return null;

      const trackingConfig = findTrackingConfig(tracking, card?.trackingKeyValue || '');
      const ctaTracking = mapTrackingProperties(trackingConfig);

        return (
          <div key={`${card.header}-${index}`} className="pointswrapper__card">
            <CardVertical
              cardVerticalVariations={CardVerticalVariations.Standard}
              header={card.header}
              headerTag={Types.tags.paragraph}
              description={card.description}
              ctaLink={card.ctaLink}
              openInNewTab={card.openInNewTab}
              dynamicMedia={card.dynamicMedia}
              componentId={`${componentId || 'pointsWrapper'}-card-${index}`}
              hideTopicDetail
              imageLoadType="lazy"
              trackingProperties={ctaTracking}
            />
          </div>
        );
      })}
    </div>
  );
};
